import React from "react";
import { IonFab, IonFabButton, IonSpinner } from "@ionic/react";

const LoadingSpinner: React.FC = () => (
    <IonFab slot="fixed" vertical="center" horizontal="center">
        <IonFabButton>
            <IonSpinner name="lines-sharp"></IonSpinner>
        </IonFabButton>
    </IonFab>
);

export default LoadingSpinner;
